<template>
    <div class="gdpr-invites">
        <names-list
            ref="namesList"
            :validate="validate"
            subTitle="Invite those of your colleagues whose document locations you want scanned for GDPR risks."
            :regexForSplittingWhenPasting="new RegExp(',|;| |(?:\\n\\r)|\\n|\\t')"
            :addTagOnKeys="['Enter' , ';' , ',' , ' ', 'Tab']"
            placeHolder="Insert emails"></names-list>
        <div class="bottom-action">
            <button @click="save" class="continue simple">Next</button>
            <button @click="back" class="back simple">Back</button>
        </div>
    </div>
</template>

<script>

import { loading } from '@/account/utils'
import { Defaults } from 'archii-web-components'
import { mapState } from 'vuex'

const ALL_GROUPS_NAME = 'All users'

module.exports = {

    created () {
        this.$store.commit('updatePageInfo', {title: 'Invite colleagues'})
        this.$store.dispatch('getAllGroups')
    },

    computed: {
        ...mapState({
            allGroups: 'groups'
        })
    },

    data () {
        return {
            validate: 'email'
        }
    },

    methods: {
        back: function() {
            this.$store.commit('back')
        },

        save: loading(function() {
            return this.$Api.admin.sendInvitation({
                roles: [Defaults.ROLES.USER.id, Defaults.ROLES.GDPR.id],
                message: "",
                user_emails: this.$refs.namesList.names,
                access_groups: this.allGroups.filter(g => {
                    g.name == ALL_GROUPS_NAME
                }).map(g => g.id)
            }).then(res => {
                this.$store.commit('next')
            }).catch(err => {
                this.$store.dispatch('error', "Error sending the invites")
            })
        }),
    }
}

</script>



// WEBPACK FOOTER //
// apps/account/GDPRInvites.vue